import { GalleryService } from './gallery.service';
import { GalleryRecordMetadata, GALLERY_COLLECTIONS } from 'shared';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  collectionKeys = Object.keys(GALLERY_COLLECTIONS);
  COLLECTIONS = GALLERY_COLLECTIONS;
  collectionThumbnails = new Map<string, string>();
  isBrowser = true;

  constructor(
    public activeRoute: ActivatedRoute,
    private galleryService: GalleryService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async ngOnInit(): Promise<void> {
    if (this.isBrowser) {
      await this.galleryService.fetchMetadata();
      // fetch gallery thumbnails
      const meta: GalleryRecordMetadata = this.galleryService.galleryRecordMetadata;
      for (const collection in meta.galleryCollectionData) {
        if (meta.galleryCollectionData[collection]) {
          const thumbs = meta.galleryCollectionData[collection].thumbnailURLs;
          const thumb =
            thumbs.length > 0
              ? thumbs[Math.floor(thumbs.length * Math.random())]
              : 'assets/images/missing_photo.jpg';
          this.collectionThumbnails.set(collection, thumb);
        }
      }
    }
  }
}
